import React from 'react';
import styled from 'styled-components';
import { colors, HealtheraButton } from '../../../../healtheraComponents';
import Note from '../../../Notes/Note';
import Spinner from '../../../Shared/Spinner';
import { MODAL } from '../../constants';
import DetailsLine from './DetailsLine';
import { ModalContext } from './PharmacyModalContent';

const PharmacyInfo = ({ pharmacy, isLoading, notes }) => {
  const { setModalContent } = React.useContext(ModalContext);

  const addNotesRedirectHandler = () => {
    setModalContent(MODAL.ADD_NOTE);
  };

  const {
    address,
    postcode,
    country,
    city,
    pharmacy_contact,
    pharmacy_email,
    telephone,
  } = pharmacy || {};

  return (
    <DetailsContainer>
      {isLoading ? (
        <Spinner />
      ) : !(pharmacy || isLoading) ? (
        'Pharmacy not found.'
      ) : (
        <>
          <DetailsFieldSet>
            <DetailsTitle>Branch Address</DetailsTitle>
            <DetailsLine title="Address" value={address} />
            <DetailsLine title="City" value={city} />
            <DetailsLine title="Country" value={country} />
            <DetailsLine title="Postcode" value={postcode} />
          </DetailsFieldSet>
          <DetailsFieldSet>
            <DetailsTitle>Main Contact Person</DetailsTitle>
            <DetailsLine title="Name" value={pharmacy_contact} />
            <DetailsLine title="Email" value={pharmacy_email} />
            <DetailsLine title="Telephone" value={telephone} />
          </DetailsFieldSet>
          {notes.length ? (
            <Note title="Last note" small note={notes[0]} />
          ) : null}
          <ButtonContainer>
            <HealtheraButton
              onClick={addNotesRedirectHandler}
              height="34px"
              width="auto"
            >
              More notes
            </HealtheraButton>
          </ButtonContainer>
        </>
      )}
    </DetailsContainer>
  );
};

const DetailsContainer = styled.div`
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  width: 400px;
  background-color: ${colors.FADED_LIGHT};
  padding: 16px;
  font-family: 'SFProRegular';
  font-size: 16px;
`;

const DetailsTitle = styled.h3`
  margin: 0;
  margin-bottom: 20px;
  font-weight: 300;
`;

const DetailsFieldSet = styled.div`
  margin-bottom: 1rem;
`;

const ButtonContainer = styled.p`
  margin: 0;
  margin-top: 8px;
  width: 100%;
  display: flex;
  flex-direction: column;
`;

export default PharmacyInfo;
